import React, { useEffect, useState } from "react";
import Logo from "../../Pyragon/PyraGon.png";
import "./pyracoin.css";
// import backGround from "../../Pyragon/03.png";
// import backGround from "../../Pyragon/09.png";
import backGround from "../../Pyragon/34.svg";
import $ from "jquery";
import Image from "../../Pyragon/Website Assets/How to Buy Section/PANCAKESWAP1.png";


import Purchase from '../../site/content/purchase.json'
import Slide from 'react-reveal/Slide';


const Pyracoin = () => {
  const [changepos, setChangePos] = useState(0);

  useEffect(() => {
    let oldVal = 0;

    $("div").on("wheel", function (e) {
      if (e.originalEvent.deltaX < 0) {
                oldVal += 2;
        setChangePos(oldVal);
      } else if(e.originalEvent.deltaX > 0){
        oldVal -= 2;
            setChangePos(oldVal);
      }
    });
  }, []);

  return (

    <div className="pyracoin pyracoin-animation">

      {/* <img
        class="demo-bg-tokenomics"
        src={backGround}
        alt=""
        style={{ left: changepos }}
      /> */}

      <div id="pyracoin-group-1">
        <Slide left>
        <div id="pyracoin-left-card">
          <div className="token converter">
            <div className="token-img">
                <img src={Image} alt="Image"/>
            </div>
          </div>
          <button className="buy-now">BUY NOW</button>
          {/* <div id="pyracoin-left-card-inner">
            <h3 id="pyracoin-left-card-inner-heading-1">Purchase PYRA coin</h3>
            <h4 style={{ color: "#535195" }}>Avaliable on Pancakeswap</h4>
            <button>BUY NOW</button>

            <div id="share-bar"></div>
          </div> */}
        </div>
        </Slide>
        <Slide right cascade>
        <div id="pyracoin-right">
          <div>
            <span style={{color:'#6c5eb2'}}>HOW TO BUY</span>
            <span> PYRA</span>
            <span style={{color:'#6c5eb2', marginLeft : "10px"}}>COIN</span>
          </div>

          <h3>{Purchase["sub-heading"]}</h3>

          <p>{Purchase["point-one"]}</p>
          <p>{Purchase["point-two"]}</p>
          <p>{Purchase["point-three"]} </p>
          <p>{Purchase["point-four"]}</p>

          <p style={{marginTop : "25px"}}>{Purchase["para-one"]}</p>
          <p style={{marginTop : "25px"}}>{Purchase["para-two"]}</p>

          <h3 id="pyracoin-left-lower-heading" style={{color:'rgb(99, 34, 185)'}}>{Purchase["sub-heading-two"]}</h3>
        </div>
        </Slide>
      </div>

    </div>
  );
};

export default Pyracoin;
